import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';

// Compact category label for list/table views. "Other" shows as a short chip;
// the vendor's custom description appears in a hover tooltip.
const CategoryChip = ({
  categoryName,
  categorySlug,
  categoryOtherDescription,
  row,
  sx,
}) => {
  const name = categoryName ?? row?.category_name;
  const slug = categorySlug ?? row?.category_slug;
  const otherDescription = categoryOtherDescription ?? row?.category_other_description;

  if (!name) return null;

  const isOther = slug === 'other';
  const label = isOther ? 'Other' : name;
  const chip = (
    <Chip size="small" variant="outlined" color="primary" label={label} />
  );

  const content = isOther && otherDescription ? (
    <Tooltip
      title={otherDescription}
      arrow
      slotProps={{
        tooltip: { sx: { maxWidth: 360, whiteSpace: 'pre-wrap' } },
      }}
    >
      <Box component="span" sx={{ display: 'inline-block' }}>
        {chip}
      </Box>
    </Tooltip>
  ) : chip;

  if (sx) {
    return <Box sx={sx}>{content}</Box>;
  }

  return content;
};

export default CategoryChip;
